var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-6 col-12"},[_c('InfoBlock')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }